<template>
  <div v-if="!loading">
    <div class="section">
      <div class="container section__content">
        <h2 class="std__subtile">{{$t("zodiac_signs")}}</h2>
        <p class="std__subtile neon lg">
          {{zodiacs.name}}
          <span class="dateStamp">{{zodiacs.date}}</span>
        </p>
        <div class="row">
          <div class="col-md-8 order-2 order-md-1 m2--topBtm">
            <ul class="nav nav-tabs custom" id="zodiacTraits" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="mentalTraits-tab"
                  data-toggle="tab"
                  href="#mentalTraits"
                  role="tab"
                  aria-controls="mentalTraits"
                  aria-selected="false"
                >{{$t("mental")}}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="physicalTraits-tab"
                  data-toggle="tab"
                  href="#physicalTraits"
                  role="tab"
                  aria-controls="physicalTraits"
                  aria-selected="true"
                >{{$t("physical")}}</a>
              </li>
            </ul>
            <div class="tab-content" id="zodiacTraits">
              <div
                class="tab-pane fade show active"
                id="mentalTraits"
                role="tabpanel"
                aria-labelledby="mentalTraits-tab"
              >
                <span v-if="language==='english'">
                  <p
                    class="std__txt"
                    v-for="zodiac in zodiacs.mental_traits"
                    :key="zodiac.key"
                  >{{zodiac}}</p>
                </span>
                <span v-if="language!=='english'">
                  <p
                    class="std__txt"
                    v-for="zodiac in zodiacs.mentalTranslate"
                    :key="zodiac.key"
                  >{{zodiac}}</p>
                </span>
                <!-- <span v-if="language==='greek'">
                  <p
                    class="std__txt"
                    v-for="zodiac in zodiacs.mentalGR"
                    :key="zodiac.key"
                  >{{zodiac}}</p>
                </span>
                <span v-if="language==='malay'">
                  <p
                    class="std__txt"
                    v-for="zodiac in zodiacs.mentalMY"
                    :key="zodiac.key"
                  >{{zodiac}}</p>
                </span> -->
              </div>
              <div
                class="tab-pane fade"
                id="physicalTraits"
                role="tabpanel"
                aria-labelledby="physicalTraits-tab"
              >
              <span v-if="language==='english'">
                <p
                  class="std__txt"
                  v-for="zodiac in zodiacs.physical_traits"
                  :key="zodiac.key"
                >{{zodiac}}</p>
              </span>
              <span v-if="language!=='english'">
                <p
                  class="std__txt"
                  v-for="zodiac in zodiacs.physicalTranslate"
                  :key="zodiac.key"
                >{{zodiac}}</p>
              </span>
              <!-- <span v-if="language==='greek'">
                <p
                  class="std__txt"
                  v-for="zodiac in zodiacs.physicalGR"
                  :key="zodiac.key"
                >{{zodiac}}</p>
              </span>
              <span v-if="language==='malay'">
                <p
                  class="std__txt"
                  v-for="zodiac in zodiacs.physicalMY"
                  :key="zodiac.key"
                >{{zodiac}}</p>
              </span> -->
              </div>
            </div>
          </div>
          <div class="col-md-4 order-1 order-md-2 m2--topBtm">
            <div class="imagePlaceholder sign">
              <span class="signIcon__img" :style="{ '-webkit-mask': `url(${zodiacs.icon})` }"></span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 m2--topBtm">
            <p class="std__subtile md bdr">{{$t("favorites")}}</p>
            <div class="rowContent">
              <span v-if="language==='english'">
                <p
                class="std__txt"
                v-for="(zodiac,index) in zodiacs.favorites"
                :key="zodiac.key"
              >{{ index+1 }}. {{zodiac}}</p>
              </span>
              <span v-if="language!=='english'">
                <p
                class="std__txt"
                v-for="(zodiac,index) in zodiacs.favTranslate"
                :key="zodiac.key"
              >{{ index+1 }}. {{zodiac}}</p>
              </span>
              <!-- <span v-if="language==='greek'">
                <p
                class="std__txt"
                v-for="(zodiac,index) in zodiacs.favoritesGR"
                :key="zodiac.key"
              >{{ index+1 }}. {{zodiac}}</p>
              </span>
              <span v-if="language==='malay'">
                <p
                class="std__txt"
                v-for="(zodiac,index) in zodiacs.favoritesMY"
                :key="zodiac.key"
              >{{ index+1 }}. {{zodiac}}</p>
              </span> -->
            </div>
          </div>
          <div class="col-md-6 m2--topBtm">
            <p class="std__subtile md bdr">{{$t("hates")}}</p>
            <div class="rowContent">
              <span v-if="language==='english'">
                <p
                class="std__txt"
                v-for="(zodiac,index) in zodiacs.hates"
                :key="zodiac.key"
              >{{ index+1 }}. {{zodiac}}</p>
              </span>
              <span v-if="language!=='english'">
                <p
                class="std__txt"
                v-for="(zodiac,index) in zodiacs.hateTranslate"
                :key="zodiac.key"
              >{{ index+1 }}. {{zodiac}}</p>
              </span>
              <!-- <span v-if="language==='greek'">
                <p
                class="std__txt"
                v-for="(zodiac,index) in zodiacs.hatesGR"
                :key="zodiac.key"
              >{{ index+1 }}. {{zodiac}}</p>
              </span>
              <span v-if="language==='malay'">
                <p
                class="std__txt"
                v-for="(zodiac,index) in zodiacs.hatesMY"
                :key="zodiac.key"
              >{{ index+1 }}. {{zodiac}}</p>
              </span> -->
            </div>
          </div>
        </div>
        <div class="row m2--topBtm">
          <div class="col-md-3 col-sm-6 col-6 zodiacCol">
            <h2 class="std__subtile md">{{$t("ruling_planet")}}</h2>
            <img class="planet_img" :src="zodiacs.planet_img" alt />
            <p class="std__txt" v-if="language==='english'">{{zodiacs.planet}}</p>
            <p class="std__txt" v-if="language!=='english'">{{zodiacs.rltranslate}}</p>
            <!-- <p class="std__txt" v-if="language==='greek'">{{zodiacs.rulling_planetGR}}</p>
            <p class="std__txt" v-if="language==='malay'">{{zodiacs.rulling_planetMY}}</p> -->
          </div>
          <div class="col-md-3 col-sm-6 col-6 zodiacCol">
            <h2 class="std__subtile md">{{$t("compatibility")}}</h2>
            <div v-on:click="getZodiacSign(zodiacs.compatibility.toLowerCase())">
              <img class="compatibility_img" :src="zodiacs.compatibility_img" alt />
              <p class="std__txt">{{zodiacs.compatibility}}</p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-6 zodiacCol">
            <h2 class="std__subtile md">{{$t("element")}}</h2>
            <router-link
              class="favorites"
              :to="{ name: 'ElementsDetails', params: { element: zodiacs.element } }"
            >
              <img class="elem_img" :src="zodiacs.element_img" alt />
              <p class="std__txt" v-if="language==='english'">{{zodiacs.element}}</p>
              <p class="std__txt" v-if="language!=='english'">{{zodiacs.elemTranslate}}</p>
            </router-link>
          </div>
          <div class="col-md-3 col-sm-6 col-6 zodiacCol">
            <h2 class="std__subtile md">{{$t("color")}}</h2>
            <span v-html="zodiacs.colorCode"></span>
            <p class="std__txt" v-if="language==='english'">{{zodiacs.color}}</p>
            <p class="std__txt" v-if="language!=='english'">{{zodiacs.colorTranslate}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import colors from "./colors.json";
import { mapGetters,mapActions } from "vuex";

const proxyurl = "https://cors-anywhere.herokuapp.com/";
const URL = "https://zodiacal.herokuapp.com/";
const zUrl = "https://aztro.sameerkumar.website/?day=today&sign=";

var TJO = require("translate-json-object")();

export default {
  data() {
    return {
      data: {},
      zodiacs: {},
      zodiac: "",
      colors: colors,
      colorCode: "",
      color: "",
      colorTranslate: "",
      compatibility: "",
      compatibility_img: "",
      date: "",
      loading: true,
    };
  },
  computed: mapGetters(["language", "translateCode"]),
  mounted() {
    this.getZodiacSign(this.$route.params.zodiac);
  },
  methods: {
    async getZodiacSign(name) {
      const zodiac = {
        url: zUrl + name,
        method: 'POST'
      }
      await this.$axios(zodiac).then((res) => {
        console.log(res)
        this.loading = false
        // this.data = res.data;
        this.color = res.data.color;
        this.compatibility = res.data.compatibility;
        this.compatibility_img = require(`../../assets/mobiscope/imgs/horoscope_icon/${res.data.compatibility}.svg`);
        this.date = res.data.date_range;
      })
      .catch((err) => {
        console.error(err);
      })
      //additional details
      const additional = {
        url: proxyurl + URL + name,
        method: 'GET'
      }

      await this.$axios(additional).then((res) => {
        this.loading = false
          let zod = res.data[0];

          let favo = []
          let fav = []
          let hate = []
          let hat = []

          //capitalizing the very first letter in each sentence
         
          for(let i=0; i<zod.favorites.length; i++){
            favo = zod.favorites[i].trim()
            fav[i] = favo.replace(/^./, favo[0].toUpperCase());
          }

          //capitalizing the very first letter in each sentence
          for(let i=0; i<zod.hates.length; i++){
            hate = zod.hates[i].trim()
            hat[i] = hate.replace(/^./, hate[0].toUpperCase());
          }
          zod.favorites = fav
          zod.hates = hat
          zod.planet = zod.ruling_planet[0];
          zod.planet_img = require(`../../assets/mobiscope/imgs/planet/${zod.ruling_planet[0]}.svg`);
          zod.icon = require(`../../assets/mobiscope/imgs/horoscope_icon/${zod.name}.svg`);
          zod.element_img = require(`../../assets/mobiscope/imgs/elements/${zod.element}.svg`);
          zod.color = this.color;
          zod.colorCode = `<div class="circle" style="background: ${this.getColorCode(this.color)}"></div>`;
          zod.compatibility = this.compatibility;
          zod.compatibility_img = this.compatibility_img;
          zod.date = this.date

          let test = {}
          let ar = []
          let gr = []
          let ms = []

          TJO.init({
            // googleApiKey: 'AIzaSyBm4nfZjFUrt4A6MKWxHxCKIT3L4h8VPH8',
            googleApiKey: 'AIzaSyCq1acQaQt46Yx2VK1BrlYm19SN7hqbf04',
            // yandexApiKey: "trnsl.1.1.20191111T072241Z.a4ad72c3f47a325f.7a1d4907e47128f839d39d2241ed3fcc0414ada7"
          });

          var desc = {
            favTranslate: zod.favorites.join("/"),
            hateTranslate: zod.hates.join("/"),
            mentalTranslate: zod.mental_traits.join("/"),
            physicalTranslate: zod.physical_traits.join("/"),
            elemTranslate: zod.element,
            rltranslate: zod.ruling_planet[0],
            colorTranslate: zod.color,
          };

          if(this.translateCode != ""){
            TJO.translate(desc, this.translateCode).then((data) => {
              zod.favTranslate = data.favTranslate.split("/")
              zod.hateTranslate = data.hateTranslate.split("/")
              zod.mentalTranslate = data.mentalTranslate.split("/")
              zod.physicalTranslate = data.physicalTranslate.split("/")
              zod.elemTranslate = data.elemTranslate
              zod.rltranslate = data.rltranslate
              zod.colorTranslate = data.colorTranslate
              // console.log(data.yester) //example
            })
          }
          
          setTimeout(()=>{
            this.zodiacs = zod
          }, 2000)
      })
      .catch((err) => {
        console.error(err);
      })

    },
    load_page() {
      location.reload();
    },
    getColorCode(color) {
      let co = this.colors.colors;

      let found = co.find((element) => {
        return element.name == color;
      });

      return found.hex;
    }
  }
};
</script>

<style lang="scss">
.planet_img,
.elem_img,
.compatibility_img {
  width: 80px;
  margin-bottom: 8px;
  border-radius: 50%;
}
.circle {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  border: 2px solid white;
}
.std__txt {
  color: white;
}
.imagePlaceholder.sign {
  text-align: center;
  .signIcon__img {
    width: 110px;
    height: 110px;
  }
}
.zodiacCol {
  text-align: center;
  .circle {
    margin: 0 auto;
  }
  .std__txt {
    margin-top: 15px;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobiscope/ZodiacDetails.vue